import { addDisplayName, addHandlers, flowMax } from 'ad-hok'
import { FC } from 'react'
import { addApi } from 'shared/src/api'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { Button } from './Button'

interface Props {
  reload: () => void
}

export const MediaExtraButtons: FC<Props> = flowMax(
  addDisplayName('MediaExtraButtons'),
  addApi,
  addTranslationHelpers,
  addHandlers({
    onClearPositions:
      ({ api, reload }) =>
      () => {
        api.media.clearPositions().then(() => reload())
      },
  }),
  ({ onClearPositions, t }) => (
    <>
      <Button
        text={t('admin.resources.media.clearPositions')}
        onClick={onClearPositions}
      />
    </>
  )
)
